import { useMemo } from 'react';

export type OrganizationSizeValue =
  | '1-10'
  | '11-50'
  | '51-100'
  | '101-250'
  | '251-1000'
  | '1000-5000'
  | '5000+';

export interface OrganizationSizeChoice {
  label: string;
  value: OrganizationSizeValue;
  min: number;
}

export const useOrganizationSizeChoices = (): OrganizationSizeChoice[] => {
  return useMemo(() => {
    return [
      { value: '1-10', min: 1, label: 'activation:saml-sso.form.option-ten-employees' },
      { value: '11-50', min: 11, label: 'activation:saml-sso.form.option-fifty-employees' },
      {
        value: '51-100',
        min: 51,
        label: 'activation:saml-sso.form.option-hundred-employees',
      },
      {
        value: '101-250',
        min: 101,
        label: 'activation:saml-sso.form.option-twofifty-employees',
      },
      {
        value: '251-1000',
        min: 251,
        label: 'activation:saml-sso.form.option-thousand-employees',
      },
      {
        value: '1000-5000',
        min: 1000,
        label: 'activation:saml-sso.form.option-fivethousand-employees',
      },
      {
        value: '5000+',
        min: 5000,
        label: 'activation:saml-sso.form.option-morethan-fivethousand-employees',
      },
    ];
  }, []);
};
